import React, { useEffect } from "react";
import { Image, Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { OAuthProvider } from "@nestcoinco/hyper-api-gateway-api-client";
import { useTranslation } from "react-i18next";

import "./StartAuthScreen.scss";
import PrimaryActionButton from "../../Buttons/PrimaryActionButton/PrimaryActionButton";
import { AuthFlow, OnboardingSteps, ROUTES } from "../../../utils/constants";
import LatestWinsSlider from "../LatestWinsSlider/LatestWinsSlider";
import ImageVerticalCardCarousel from "../../../images/vertical-card-carousel.png";
import { setStoredAuthFlow } from "../../../utils/storage";
import useAnalytics from "../../../hooks/useAnalytics";
import { SignupOptionProperty } from "../../../utils/analytics";
import { ThemeVariant } from "../../../utils/constants/generic-types";
import useOnboardingSteps from "../../../hooks/useOnboardingSteps";
import OnboardingHeader from "../../Headers/OnboardingHeader/OnboardingHeader";
import useAuth from "../../../hooks/useAuth";
import PrimaryButtonWithBonusTag from "../PrimaryButtonWithBonusTag/PrimaryButtonWithBonusTag";
import { CustomSpinner } from "../../CustomSpinner/CustomSpinner";

function StartAuthScreen() {
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const { sendFirstOnboardingScreenEvent, sendSignupOptionsEvent } =
    useAnalytics();
  const { goToStep } = useOnboardingSteps();
  const { isAuthInProgress, handleAuthClick } = useAuth();

  const handleSignup = () => {
    sendSignupOptionsEvent(SignupOptionProperty.SIGN_UP);
    setStoredAuthFlow(AuthFlow.SIGNUP);
    goToStep(OnboardingSteps.SET_EARNINGS_GOALS);
    navigate(`${ROUTES.ROOT.SIGN_UP}`);
  };

  const handleLogin = () => {
    sendSignupOptionsEvent(SignupOptionProperty.LOG_IN);
    setStoredAuthFlow(AuthFlow.LOGIN);
    handleAuthClick(
      OAuthProvider.GOOGLE,
      ROUTES.ROOT.LOG_IN,
      ROUTES.ROOT.LOG_IN,
    );
  };

  useEffect(() => {
    sendFirstOnboardingScreenEvent();
  }, [sendFirstOnboardingScreenEvent]);

  return (
    <div className="start-auth-screen">
      <div className="position-relative modal-body">
        <header className="thumbnails-header">
          <OnboardingHeader
            showProgress={false}
            className="onboarding-header"
          />

          <Image
            src={ImageVerticalCardCarousel}
            className="thumbnails"
            alt="Game thumbnails"
          />
        </header>

        <div className="main-content">
          <Stack gap={3} className="text-content">
            <LatestWinsSlider />
            <p className="main-copy">
              {t(
                "onboarding.play_your_favourite_games_battle_with_friends_and_win_real_money",
              )}
              .
            </p>
          </Stack>
          <Stack gap={3} className="ctas-container">
            <PrimaryButtonWithBonusTag
              size="lg"
              text={t("onboarding.create_a_free_account")}
              textClassName="authButtonText"
              onClick={handleSignup}
            />
            <PrimaryActionButton
              size="lg"
              theme={ThemeVariant.DARK}
              text={
                <span className="d-inline-flex gap-1 align-items-center">
                  {t("onboarding.i_have_an_account")}
                  {isAuthInProgress ? <CustomSpinner size="sm" /> : null}
                </span>
              }
              buttonClassName="loginButton"
              textClassName="authButtonText"
              onClick={handleLogin}
            />
          </Stack>
        </div>
      </div>
    </div>
  );
}

export default StartAuthScreen;
